<main class="container">
  <div class="center-content">
    <div class="row">
      <div class="col-md-12 text-center">
        <h1>Access Denied</h1>
        <p class="lead">Sorry, you don't have permission to access this page.</p>
        
        <div class="mt-4">
          <p>This could be because:</p>
          <ul class="list-unstyled">
            <li>• You don't have the required role</li>
            <li>• Your role don't have sufficient permissions</li>
            <li>• Your session may have expired</li>
          </ul>
        </div>

        <div class="mt-4">
          <button class="btn btn-primary mr-2" (click)="goHome()">
            Go to Home Page
          </button>
          @if (returnUrl) {
<button class="btn btn-secondary" (click)="goBack()">
            Try Again
          </button>
}
        </div>

        <div class="mt-4">
          <small class="text-muted">
            If you believe this is an error, please contact your administrator.
          </small>
        </div>
      </div>
    </div>
  </div>
</main>
